import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { Fade } from 'react-awesome-reveal';
import { FaCheckCircle } from 'react-icons/fa';

const ThankYouPage = () => {
  return (
    <div>
      {/* ==================== Page Header ==================== */}
      <section className="py-5 text-center d-flex align-items-center" style={{
        minHeight: '60vh',
        background: 'linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.8)), url("/assets/banner/breadcrumb.jpg") no-repeat center center',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed'
      }}>
        <Container className="position-relative" style={{ zIndex: 2 }}>
          <Fade triggerOnce direction="down">
            <FaCheckCircle size={80} className="text-success mb-4" />
            <h1 className="display-4 fw-bold mb-3 text-white">Thank You!</h1>
            <p className="lead text-white-50 mb-4">
              Your message has been sent successfully. We'll get back to you soon.
            </p>
            <Button as={NavLink} to="/" variant="primary" size="lg">
              Back to Home
            </Button>
          </Fade>
        </Container>
      </section>
    </div>
  );
};

export default ThankYouPage;